import axios from '../../api/instance';
import {FETCH_EXPERIENCES} from './experiences';

const namespace = 'orders/';

const SET_ORDERS = namespace + 'set';
const SET_LAST_ORDER = namespace + 'set_last_order';
export const SET_FETCHING_LAST_ORDER = namespace + 'SET_FETCHING_LAST_ORDER';

export const FETCH_ORDERS = namespace + 'fetch';

export const GET_ORDERS = namespace + 'get';

export const FETCH_PDF = namespace + 'fetch_pdf';


export const FETCH_LAST_ORDER = namespace + 'fetch_last_order';
export const GET_LAST_ORDER = namespace + 'get_last_order';
export const GET_FETCHING_LAST_ORDER = namespace + 'GET_FETCHING_LAST_ORDER';

export const TYPE_MAINTENANCE = 'maintenance';
export const TYPE_REPAIR = 'repair';
export const TYPE_PROPOSAL = 'proposal';
export const TYPE_INSTALLATION = 'installation';

export default {
    state: {
        items: [
            {
                id: 1,
                date: new Date('2018-01-01'),
                price: 10.25,
                type: TYPE_MAINTENANCE,
                download_url: 'http://google.com/',
            },
            {
                id: 2,
                date: new Date('2018-01-02'),
                price: 2048.50,
                type: TYPE_REPAIR,
                download_url: 'http://google.com/',
            },
            {
                id: 3,
                date: new Date('2018-01-03'),
                price: 12345.01,
                type: TYPE_PROPOSAL,
                download_url: 'http://google.com/',
            },
            {
                id: 4,
                date: new Date('2018-01-04'),
                price: 0.00,
                type: TYPE_INSTALLATION,
                download_url: 'http://google.com/',
            }
        ],
        last_order: null,
        fetchingLastOrder: false
    },
    mutations: {
        [SET_ORDERS]: (state, orders) => state.items = orders,
        [SET_LAST_ORDER]: (state, order) => state.last_order = order,
        [SET_FETCHING_LAST_ORDER]: (state, fetching) => state.fetchingLastOrder = fetching
    },
    actions: {
        async [FETCH_ORDERS] ({commit})  {
            let orders = await axios.get('orders/api/orders');
            commit(SET_ORDERS, orders);
        },
        async [FETCH_LAST_ORDER] ({commit}) {
            try {
                commit(SET_FETCHING_LAST_ORDER, true);
                let order = await axios.get('/salt/api/refills/order');
                commit(SET_LAST_ORDER, order);
            } finally {
                commit(SET_FETCHING_LAST_ORDER, false);
            }
        },
        async [FETCH_PDF] ({commit}, url){
            let fullUrl = 'orders/api/orders/file' + url;
            let response = await axios.get(fullUrl, {responseType: 'arraybuffer'});
            const file = new Blob(
                [response],
                {type: 'application/pdf'});
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
        }
    },
    getters: {
        [GET_ORDERS]: (state) => state.items,
        [GET_LAST_ORDER]: (state) => state.last_order,
        [GET_FETCHING_LAST_ORDER]: (state) => state.fetchingLastOrder
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/orders.js